export const reformatExperimentsForTracking = (experiments) => {
	let result = {};
	experiments?.forEach((e) => {
		result = { ...result, [e.name]: e.variant };
	});
	return result;
};

export default reformatExperimentsForTracking;
